<ng-container>
  <app-organization-popup
    id="comOrganization"
    [organizations]="organizations"
    [applications]="applications"
  >
  </app-organization-popup>
</ng-container>
